import { z } from "zod";
import { ProgramType } from "../enums/ProgramType";
import { SourceStatus } from "../enums/SourceStatus";
import { dateSchema } from "../utils/DateSchema";
import { idSchema } from "../utils/IdSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";
import { ExcessLiabilityPolicySchema } from "./ExcessLiabilityPolicy";
import { GeneralLiabilityPolicySchema } from "./GeneralLiabilityPolicy";

export const SourceSchema = z.object({
  id: idSchema(),
  name: requiredStringSchema().max(250),
  status: SourceStatus,
  programType: ProgramType.optional(),
  firstNamedInsureds: z.array(nameSchema()).min(1),
  producingOffices: z.array(nameSchema()).min(1),
  description: z.string().max(2000).optional(),
  notes: z.string().max(2000).optional(),
  generalLiability: GeneralLiabilityPolicySchema,
  excessLiabilities: z.array(ExcessLiabilityPolicySchema).optional(),
  updatedDate: dateSchema().optional(),
});

export type Source = z.infer<typeof SourceSchema>;
